import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Footer() {
  const footerArticles = articles.filter((a) =>
    ['sugargoo-review-2026', 'sugargoo-shipping-cost-guide', 'sugargoo-coupon-discount-guide', 'sugargoo-spreadsheet-ultimate-guide', 'best-sugargoo-spreadsheet-beginners', 'sugargoo-qc-photos-guide'].includes(a.slug)
  );

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-file-list-3-line text-lg"></i>
              </span>
              <span className="font-heading text-lg text-foreground-900">Sugargoo Sheet</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-xs">
              Your independent resource for Sugargoo Spreadsheet discoveries, product guides, shopping tips, and the latest community finds. Not affiliated with Sugargoo official.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Home</Link>
              <a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Categories</a>
              <Link to="/article/sugargoo-spreadsheet-ultimate-guide" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Shopping Guide</Link>
              <Link to="/article/sugargoo-review-2026" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Sugargoo Review</Link>
              <Link to="/article/sugargoo-shipping-cost-guide" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Shipping Guide</Link>
              <Link to="/article/sugargoo-coupon-discount-guide" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Coupon Guide</Link>
              <a href="#faq" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">FAQ</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">SEO Guides</h4>
            <div className="flex flex-col gap-2">
              {footerArticles.map((a) => (
                <Link
                  key={a.slug}
                  to={`/article/${a.slug}`}
                  className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors"
                >
                  {a.title.length > 40 ? a.title.substring(0, 40) + '...' : a.title}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">Popular Categories</h4>
            <div className="flex flex-wrap gap-2">
              {categories.slice(0, 10).map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-3 py-1.5 rounded-full bg-background-200/70 text-xs text-foreground-600 hover:bg-background-300 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} sugargoosheet.xyz — Independent informational resource.
          </p>
          <p className="text-xs text-foreground-400">
            We are not Sugargoo official. All trademarks belong to their respective owners.
          </p>
        </div>
      </div>
    </footer>
  );
}